export class QnaireAnalysisDTO {
    PK;
    SK;
    id;
    createdAt;
    updatedAt;
    type;
    tenantId;
    questionnaireId;
    lookupGraphType;
    textGraphType;
    filterQuestions;
    startDate;
    endDate;
    userGroupId;
    cloudTenants;
    uniquePerUser;
    kmlFileId;
    kmlName;
    kmlDistanceOption;
    kmlDistanceOptionValue;
    kmlMarkers;
    kmlPolygons;
    kmlPolylines;

    constructor(analysis, tenant) {
        this.PK = `${analysis.tenantId}#QNAIREANALYSIS`;
        this.SK = `${analysis.questionnaireId}#ANALYSIS#`;
        this.type = "QNAIREANALYSIS";
        this.tenantId = analysis.tenantId;
        this.questionnaireId = analysis.questionnaireId;
        this.lookupGraphType = analysis.lookupGraphType;
        this.textGraphType = analysis.textGraphType;
        this.filterQuestions = analysis.filterQuestions ? analysis.filterQuestions : null;
        this.startDate = analysis.startDate ? analysis.startDate : null;
        this.endDate = analysis.endDate ? analysis.endDate : null;
        this.userGroupId = analysis.userGroupId ? analysis.userGroupId : null;
        this.cloudTenants = analysis.cloudTenants ? analysis.cloudTenants : tenant.defaultCloudTenants ? tenant.defaultCloudTenants : [];
        this.uniquePerUser = analysis.uniquePerUser ? analysis.uniquePerUser : false;
        this.kmlFileId = analysis.kmlFileId ? analysis.kmlFileId : null;
        this.kmlName = analysis.kmlName ? analysis.kmlName : null;
        this.kmlMarkers = analysis.kmlMarkers ? analysis.kmlMarkers : [];
        this.kmlPolygons = analysis.kmlPolygons ? analysis.kmlPolygons : [];
        this.kmlPolylines = analysis.kmlPolylines ? analysis.kmlPolylines : [];
        this.kmlDistanceOption = analysis.kmlDistanceOption ? analysis.kmlDistanceOption : null;
        this.kmlDistanceOptionValue = analysis.kmlDistanceOptionValue ? analysis.kmlDistanceOptionValue : 1;
    }
}